<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body" style="padding-bottom: 20px">
            <div class="flex" style="height: 100%">
                <div class="flex-center" style="height: 100%;width:100%">
                    <div style="height: 100%;width: 100%;vertical-align: middle;text-align: center" id="player1">
                        <!-- <video  id="myPlayer1" :src="video.liveAddress" style="width= 100%; height=100%; object-fit: fill" controls playsInline webkit-playsinline muted>
                        </video> -->
                        <div id = "video">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAction } from '@/api/manage'
import axios from 'axios'
import '@/utils/video/imouplayer.js'
export default {
    props: {
        titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('视频监控'),
            videoIng:require("@/assets/images/video.jpg"),
            videolist: [],
            //player: {},
            video: {rtmpHd: ''},
            url: {
                queryVideoPathList: '/jeecg-charge/video/videoControl/queryVideoPathList',
            },
            player:null,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.queryVideo()
        })
    },
    methods:{
        queryVideo() {
            /*
            this.videolist = [];
            let accessToken = 'at.0jssocpa9j55ref1btmsvmdc694pas8x-708b3efiar-00dvaia-lyxe0kraw'
            let url = 'http://39.105.198.146:8119'
            var params = {userid: 'admin',userid_datasource: 'admin'};
            var _this = this;
            axios.post(url + '/xf/player/getListInfo?accessToken=' +accessToken, params,{headers: {'content-type': 'application/x-www-form-urlencoded;charset=utf-8'}}).then(function (response) {
                var msg = response.data;
                if (msg.code == 200) {
                    _this.videolist = msg.data;
                    _this.video = msg.data[0]
                    setTimeout(() => {
                    _this.player = new EZuikit.EZUIPlayer('myPlayer1');
                    // 播放
                    _this.player.load();
                    // 播放
                    //_this.player.play();
                    }, 500);
                } else {
                    log('视频请求出错');
                }
            });
            */
            this.player = new ImouPlayer('#video');
            getAction(this.url.queryVideoPathList,{deviceId: '6JO10E1PAZF0E45'}).then(res=>{
                if(res.success){
                    let pathList = res.result;
                    this.videolist = pathList;
                    if(pathList.length>9) {
                        pathList= pathList.slice(0,9)
                    }
                    //播放器初始化
                    this.player.setup({
                    src: pathList,
                    // src: [
                    //   {
                    //     // url拼接说明请见：1.3 轻应用播放地址说明
                    //     url: 'imou://open.lechange.com/6JO10E1PAZF0E45/0/1?streamId=1',
                    //     // 播放Token，通过接口getKitToken获取，具体请见：1.4 getKitToken接口协议说明 
                    //     kitToken: 'Kt_hz99dfd69ed77941d1bebf25c6304c58', 
                    //   },
                    //   {
                    //     // url拼接说明请见：1.3 轻应用播放地址说明
                    //     url: 'imou://open.lechange.com/6JO10E1PAZF0E45/1/1?streamId=1',
                    //     // 播放Token，通过接口getKitToken获取，具体请见：1.4 getKitToken接口协议说明 
                    //     kitToken: 'Kt_hzfb8108d05913449ba705a6e95a4107', 
                    //   },
                    //   {
                    //     // url拼接说明请见：1.3 轻应用播放地址说明
                    //     url: 'imou://open.lechange.com/6JO10E1PAZF0E45/2/1?streamId=1',
                    //     // 播放Token，通过接口getKitToken获取，具体请见：1.4 getKitToken接口协议说明 
                    //     kitToken: 'Kt_hz605543b78ef84a2a8be560fd0cb0bc', 
                    //   }
                    // ], // 播放地址
                    width: '100%', // 播放器宽度
                    height: '100%', // 播放器高度
                    poster: '', // 封面图url
                    autoplay: true, // 是否自动播放
                    controls: true, // 是否展示控制栏
                    setMultiScreen: 9,// 设置多屏
                    });
                    this.player.play();
                }
            })
        }
    }
}
</script>
<style scoped>
.videoImg{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
#myPlayer1{
    max-width: 1200px;
    /*min-width: 400px;*/
    width: 100%;
    /*min-height: 300px;*/
    max-height: 800px;
    height: 100%;
}
</style>